<!--隐私协议-->
<template>
    <div class="policy">
        <div class="header">
            <div class="header-back">
                <div class="title">
                    <div class="title_text">爱驿站是一家互联网婚恋公司</div>
                    <div class="title_text">专注婚恋领域十年</div>
                </div>

                <div class="title_desc">
                    <p>爱驿站创始于2014年，是一家全国连锁互联网婚恋服务品牌，拥有海量优质会员。以线下门店实名审核＋线上软件交互＋免费门店红娘服务的高效婚配服务模式，为单身男女提供真实、高效、免费的一站式婚恋服务。</p>
                </div>

                <div class="join_piece">
                    <div class="join_title">加盟政策</div>
                </div>
            </div>


        </div>

        <div class="container">
            <div class="condition">
                <div class="condition_title">招商区域</div>
                <div class="condition_text">全国</div>
            </div>
            <div class="condition">
                <div class="condition_title">招商级别</div>
                <div class="condition_text">市、区县、街道乡镇</div>
            </div>
            <div class="condition">
                <div class="condition_title">加盟费</div>
                <div class="condition_text">0 元</div>
            </div>
            <div class="condition">
                <div class="condition_title">保证金</div>
                <div class="condition_text">0 元</div>
            </div>
            <div class="condition">
                <div class="condition_title">物料费</div>
                <div class="condition_text">0 元</div>
            </div>
            <div class="condition">
                <div class="condition_title">年龄要求</div>
                <div class="condition_text">20岁以上</div>
            </div>

            <div class="condition">
                <div class="condition_title">门店面积要求</div>
                <div class="condition_text">20平方米以上</div>
            </div>

            <div class="condition">
                <div class="condition_title">门店位置要求</div>
                <div class="condition_text">无（门店、写字楼均可）</div>
            </div>
            <div class="condition">
                <div class="condition_title">店内装修要求</div>
                <div class="condition_text">整洁干净即可</div>
            </div>

            <div class="condition">
                <div class="condition_title">所有电脑、物料等自行采购，平台不会要求指定购买！</div>
            </div>

            <div class="condition">
                <div class="condition_title">五大免费支持：</div>
            </div>

            <div class="condition">
                <div class="condition_title">1、免费提供宣传资料</div>
                <div class="condition_text">平台根据提会员量按比例提供相应的免费宣传物料。</div>
            </div>
            <div class="condition">
                <div class="condition_title">2、免费协助拓展市场</div>
                <div class="condition_text">平台根据市场进展情况免费派人员协助合伙人拓展市场。</div>
            </div>
            <div class="condition">
                <div class="condition_title">3、免费软件系统</div>
                <div class="condition_text">在合作期内，我们的软件和系统免费维护使用，中途不会以任何借口增加费用。</div>
            </div>
            <div class="condition">
                <div class="condition_title">4、免费培训支持</div>
                <div class="condition_text">平台会免费提供产品知识培训、销售技能培训。</div>
            </div>
            <div class="condition">
                <div class="condition_title">5、免费提供展业工具</div>
                <div class="condition_text">平台会根据合伙人级别，提供不同的展业工具套装。</div>
            </div>
            <div class="condition">
                <div class="condition_title">四大加盟承诺</div>
                <div class="condition_text" style="margin-top: 15px">平台在市场上给予合伙人大力支持，助力合伙人获得更多市场!</div>
            </div>


            <div class="condition">
                <div class="condition_title">1、合作前不收一分钱</div>
                <div class="condition_text">我们在与您没有正式确定合作前，不会以任何名义，收取一分钱，不用担心被骗。</div>
            </div>
            <div class="condition">
                <div class="condition_title">2、专业知识包学会</div>
                <div class="condition_text">只要是我们的合伙人，我我们都会提供完善的培训，包括产品知识，销售技能知识，学不会免费再学，直到学会为止。</div>
            </div>

            <div class="condition">
                <div class="condition_title">3、年度销售返利</div>
                <div class="condition_text">当合伙人年销售额达到一定销售目标时，平台会给予年度销售返利!</div>
            </div>
            <div class="condition">
                <div class="condition_title">4、区域政策保护，不会出内部竞争</div>
                <div class="condition_text">我们的合伙人都有一定的业务开拓区域，在合作期内保证同区域内不会出现第二个内部竞争对手。</div>
            </div>

            <div class="buttons">
                <div class="station-btn" @click="onSearch">门店查询</div>
                <div class="line-btn" @click="onService">加盟热线</div>
            </div>
        </div>


        <div class="footer">
            <p>江苏爱驿站信息科技有限公司</p>
            <p style="margin-top: -15px">Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
        </div>
    </div>

</template>

<script>

import {isAndroid, isIOS, isWebView} from "@/assets/js/common";
import ayzAjax from "@/plugins/axios";

export default {
    name: "PolicyView",
    data: function () {
        return {
            franchise_phone:'0516-83000520'
        }
    },
    created() {
        this.getService()
    },
    methods: {
        onSearch(){
            let param = {};
            param.eventType = 1;//门店列表
            param = JSON.stringify(param)
            if(isIOS() && isWebView()){
                window.webkit.messageHandlers.ayz_interactive.postMessage(param);
                console.log('ios')
            }
            if (isAndroid() && isWebView()){
                window.Android.ayz_interactive(param);
            }
        },
        onService(){
            let param = {};
            param.eventType = 2;//拨打电话
            param.phoneNumber = this.franchise_phone;
            param = JSON.stringify(param)
            if(isIOS() && isWebView()){
                window.webkit.messageHandlers.ayz_interactive.postMessage(param);
                console.log('ios')
            }
            if (isAndroid() && isWebView()){
                window.Android.ayz_interactive(param);
            }
        },
        getService(){
            ayzAjax.get('/get_service').then((response) => {
                if (response.data.data.franchise_phone.length > 1){
                    this.franchise_phone = response.data.data.franchise_phone;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.policy{
    //display: flex;
    width: 100%;
    justify-content: center; /* 水平居中 */
    align-items: center;
    min-height: 300px;
    background: #F8F8F8;
    // margin: auto;
    .header{
        width: 100%;
        text-align: left;
        background-image: url('~@/assets/policy_background.png');
        //background-size: contain;
        background-size: 100% auto;
        background-repeat: no-repeat;
        padding-top: 350px;
        .header-back{
            margin-top: 20px;
            justify-content: center; /* 水平居中 */
            align-items: center;
            margin-left: 10px;
            margin-right: 10px;
            background-image: url('~@/assets/policy_background2.png');
            //background-size: contain;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding: 20px 10px 20px 10px;
            //background-color: #fff;
            .title{
                //margin-top: 10px;
                text-align: center;
                .title_text{
                    text-align: center;
                    font-weight: bold;
                    font-size: 20px;
                    margin-top: 10px;
                }
            }
            .title_desc{
                margin-top: 20px;
                text-align: left;
                padding: 0 15px;
            }
            .join_piece{
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center;
                margin-top: 20px;
                //margin-bottom: 20px;
                .join_title{
                    width: 90%;
                    height: 49px;
                    background-color: #FE405F;
                    text-align: center;
                    line-height: 49px;
                    color: #ffffff;
                    border-radius: 10px;
                    font-size: 15px;
                }
            }
        }
    }
    .container{
        min-height: 500px;
        margin: 10px 15px;
        padding: 10px 10px 80px 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
        .condition{
            padding-top: 20px;
            text-align: left;
            text-indent: 1em;
            .condition_title{
                color: #111111;
                font-size: 13px;
                font-weight: bold;
            }
            .condition_text{
                padding-top: 5px;
                font-size: 13px;
            }
        }
    }

    .buttons{
        //display: flex;
        margin-top: 50px;
        .station-btn{
            width: 140px;
            height: 50px;
            line-height: 50px;
            float: left;
            text-align: center;
            background-color: #FE405F;
            border-radius: 10px;
            color: #FFFFFF;
        }
        .line-btn{
            width: 140px;
            height: 50px;
            line-height: 50px;
            float: right;
            text-align: center;
            //background-color: #FE405F;
            border: #FE405F 1px solid;
            border-radius: 10px;
            color: #FE405F;
            //font-weight: bold;
        }
    }

}
.footer{
    margin-top: 30px;
    //padding-bottom: 20px;
    text-align: center;
    p{
        color: #A5A5A5;
        font-weight: 300;
        font-size: 12px;
    }
}
p {
     //margin-top: 3px;
     text-indent: 2em;
     line-height: 24px;
     font-size: 13px;
     color: #000000;
     overflow-wrap: break-word;  /* 标准属性 */
 }

</style>